<template>
    <div>
        <el-row>
            <el-col>
                <el-row type="flex" justify="center" :gutter="20">
                    <el-col class="text-md-left" :span="24">
                        <el-card style="margin-top: 16px;" shadow="never">
                            <div style="margin-bottom: 10px">
                                <el-row align="center">
                                    <el-col>
                                       <el-form inline>
                                            <el-form-item>
                                                <el-input
                                                    class="search-input"
                                                    v-model="searchText"
                                                    placeholder="ค้นหา ชื่อร้าน"
                                                ></el-input>
                                            </el-form-item>
                                            <el-form-item>
                                                <el-button type="primary" @click="onSearchCustomer">ค้นหา</el-button>
                                            </el-form-item>
                                       </el-form>
                                    </el-col>
                                </el-row>
                            </div>
                            <div>
                                <el-table
                                    :data="shopAllList"
                                    style="width: 100%"
                                    class="dataTbShopAllList"
                                    header-row-class-name="notify-courier-header"
                                    >
                                    <el-table-column
                                        prop="id"
                                        label="id"
                                        width="150">
                                    </el-table-column>
                                    <el-table-column
                                        prop="shopCode"
                                        label="ShopCode"
                                        width="150">
                                    </el-table-column>
                                    <el-table-column
                                        prop="label"
                                        label="ชื่อร้าน"
                                        width="300">
                                    </el-table-column>
                                    <el-table-column
                                        label="ที่อยู่ร้าน">
                                        <div class="text-md-left" slot-scope="scope">
                                        {{scope.row.address}} {{scope.row.province}} {{scope.row.district}} {{scope.row.subDistrict}} {{scope.row.zipcode}}
                                        </div>
                                    </el-table-column>
                                    <!-- <el-table-column
                                        label="จำนวนออเดอร์"
                                        header-align="center"
                                        width="200">
                                        <div class="text-md-left" slot-scope="scope">
                                            <el-input type="number" :ref="`parcel-${scope.row.id}`" v-model="scope.row.parcelNumber" placeholder="จำนวนออเดอร์"></el-input>
                                        </div>
                                    </el-table-column> -->
                                    <el-table-column
                                        label="จัดการ"
                                        header-align="center"
                                        fixed="right"
                                        width="300">
                                        <div class="text-md-center" slot-scope="scope">
                                            <!-- <el-button type="primary" @click="notifyCourier(scope.row)">Notify</el-button> -->
                                            <el-button type="primary" @click="CreateNotify(scope.row)">เรียกรถ</el-button>
                                        </div>
                                    </el-table-column>
                                </el-table>
                                <div class="custom-pagination-wrapper" >
                                    <el-pagination
                                        @size-change="changeLimitPage"
                                        @current-change="changeCurrentPage"
                                        :current-page.sync="pagination.currentPage"
                                        :page-sizes="pagination.pageSizes"
                                        :page-size="20"
                                        layout="prev, pager, next, sizes"
                                        :total="pagination.allPage * pagination.limit">
                                    </el-pagination>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                </el-row>
            </el-col>
        </el-row>
        <create-notify
            :dialogShow="dialogCreateNotify"
            :notifyDetail="notifyDetail"
            @closeModal="dialogCreateNotify = false"
            ></create-notify>
    </div>
</template>

<script>
import fgApi from '@/services/fillgoods'
import createNotify from '@/components/Courier/NotifyConfirm'
export default {
    name: 'CallNotifyCourierTab',
    components: {
        createNotify
    },
    data () {
        return {
            shopAllList: [],
            shopAllListCheck: [],
            countOrder: null,
            filtersShop: [
                { prop: 'label', value: '' }
            ],
            dateSelect: new Date(),
            histotyList: [],
            dialogCreateNotify: false,
            dialogCancelNotify: false,
            notifyDetail: {},
            notifyCancelDetail: {},
            pagination: {
                limit: 20,
                offset: 0,
                allPage: 1,
                currentPage: 1,
                pageSizes: [20, 50, 100]
            },
            searchText: ''
        }
    },
    created () {
        this.getAllshop()
    },
    methods: {
        changeLimitPage (val) {
            this.pagination.limit = val
            this.getAllshop()
        },
        changeCurrentPage (val) {
            this.pagination.offset = (this.pagination.currentPage * this.pagination.limit) - this.pagination.limit
            this.getAllshop()
        },
        onSearchCustomer () {
            this.pagination.currentPage = 1
            this.pagination.offset = 0
            this.getAllshop()
        },
        async getAllshop () {
            let loadingAllShop = this.$loading({
                target: '.dataTbShopAllList',
                text: 'กำลังโหลดข้อมูล...'
            })
            let params = {
                limit: this.pagination.limit,
                offset: this.pagination.offset,
                search: this.searchText
            }
            try {
                let res = await fgApi.shop.getAllShopNew(params)
                console.log(res)
                if (res.data) {
                    let data = []
                    res.data.forEach((name, index) => {
                        data.push({
                            label: name.name,
                            id: name.id,
                            key: name.id,
                            parcelNumber: null,
                            shopCode: name.shopCode,
                            address: name.address,
                            district: name.district,
                            subDistrict: name.subDistrict,
                            province: name.province,
                            zipcode: name.zipcode
                        })
                    })
                    this.shopAllList = data.sort(this.compareLabel)
                    this.pagination.allPage = res.allPage
                }
            } catch (error) {
                console.log(error)
            }
            loadingAllShop.close()
        },
        getShopCode (shopName) {
            shopName = shopName.split('-')
            shopName = shopName[0].split('code')
            return shopName[1]
        },
        getShopName (shopName) {
            shopName = shopName.split('-')
            return shopName[1]
        },
        CreateNotify (val) {
            this.notifyDetail = { ...val }
            this.dialogCreateNotify = !this.dialogCreateNotify
        },
        cancelNotify (val) {
            this.notifyCancelDetail = { ...val }
            this.dialogCancelNotify = !this.dialogCancelNotify
        }
    }
}
</script>

<style lang="scss">
.el-row {
    margin-bottom: 20px;
    &:last-child {
        margin-bottom: 0;
    }
}
.el-transfer-panel{
    width: 300px;
    height:400px;
}
.el-transfer-panel__list.is-filterable{
    height:300px;
    font-size:16px;
    text-align: left;
}
.custom-pagination-wrapper {
    align-self: center;
    margin-top: 16px;
    display: flex;
    justify-content: center;
}
.search-input {
    width: 510px;
}
.notify-courier-header {
    color: #FFFFFF;
    background: #000000 !important;
    th {
        background: #000000;
    }
}
</style>
